import { getNode, isCustomNodeAllowed, setActiveTool } from "../../../commands/custom-commands";
import { mergeCells, splitCell, toggleHeaderCell, CellSelection } from "prosemirror-tables";
import { customSchema } from "../../../schemas/custom-schema";

export default class TableCellsTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container has-disabled--hidden";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName = "--table-cells-anchor";
    this.buttonElement.dataset.action = "table-cells";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title =" Celdas";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Celdas";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Celdas";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--table-cells-anchor";
    this.mergeSplitButton = document.createElement("button");
    this.mergeSplitButton.setAttribute("type", "button");
    this.mergeSplitButton.className = "editor-button";
    this.mergeSplitButton.textContent = "Unir/separar";

    this.headerCellButton = document.createElement("button");
    this.headerCellButton.setAttribute("type", "button");
    this.headerCellButton.className = "editor-button";
    this.headerCellButton.textContent = "Hacer encabezado";

    this.dialogElement.appendChild(this.mergeSplitButton);
    this.dialogElement.appendChild(this.headerCellButton);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.mergeSplitAction = this.mergeSplitButtonClickCallback();
    this.headerCellAction = this.headerCellButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.mergeSplitButton.addEventListener("click", this.mergeSplitAction);
    this.headerCellButton.addEventListener("click", this.headerCellAction);
  }

  update(view) {
    const node = getNode(view.state, customSchema.nodes.table);
    if(!!node) {
      this.buttonElement.removeAttribute("disabled");
      this.mergeSplitButton.removeAttribute("disabled");
      this.headerCellButton.removeAttribute("disabled");

      const { selection } = this.view.state;

      if(!(selection instanceof CellSelection)) {
        return false;
      }

      const { $anchorCell, $headCell } = selection;
      if($anchorCell.pos !== $headCell.pos) {
        this.mergeSplitButton.textContent = "Unir";
        this.mergeSplitButton.removeAttribute("disabled");
      } else if($anchorCell.nodeAfter.attrs.colspan > 1 || $anchorCell.nodeAfter.attrs.rowspan > 1) {
        this.mergeSplitButton.textContent = "Separar";
        this.mergeSplitButton.removeAttribute("disabled");
      } else {
        this.mergeSplitButton.textContent = "Unir/separar";
        this.mergeSplitButton.setAttribute("disabled", "");
      }
    } else {
      this.buttonElement.setAttribute("disabled", "");
      this.mergeSplitButton.setAttribute("disabled", "");
      this.headerCellButton.setAttribute("disabled", "");
    }
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.mergeSplitButton.removeEventListener("submit", this.mergeSplitAction);
    this.headerCellButton.removeEventListener("submit", this.headerCellAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.mergeSplitButton = null;
    this.headerCellButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.mergeSplitAction = null;
    this.headerCellAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  mergeSplitButtonClickCallback() {
    return () => {
      const isActive = getNode(this.view.state, customSchema.nodes.table);
      if(!isActive) {
        return false;
      }

      const { selection } = this.view.state;

      if(!(selection instanceof CellSelection)) {
        return false;
      }

      const { $anchorCell, $headCell } = selection;
      if($anchorCell.pos !== $headCell.pos) {
        mergeCells(this.view.state, this.view.dispatch);
      } else if($anchorCell.nodeAfter.attrs.colspan > 1 || $anchorCell.nodeAfter.attrs.rowspan > 1) {
        splitCell(this.view.state, this.view.dispatch);
      }
      
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  headerCellButtonClickCallback() {
    return () => {
      const isActive = getNode(this.view.state, customSchema.nodes.table);
      if(!isActive) {
        return false;
      }

      toggleHeaderCell(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}